$("#select-categories").on('change', function() {
    ssr.refresh.areas()
})  

$("#btn-search").on('click', function () {
    ssr.refresh.src()
})

$("#btn-download").on('click', function () {
    ssr.download()
})

let ssr = {
    source: "ssr",
    selected: { id: "17145", type: "accum", category: "PA", acronym: "BR", name: "BRASIL"},
    workspace: '/platform',
    today: new Date(),
    init: {
        all: () => {
            $("#img-data").on('load', () => $("#btn-download").prop('disabled', false))
            $("#img-data").on('error', () => $("#btn-download").prop('disabled', true))
            ssr.init.toastr()
        },
        toastr: () => {
            toastr.options = {
                "closeButton": true,
                "debug": false,
                "newestOnTop": true,
                "progressBar": true,
                "positionClass": "toast-top-right",
                "preventDuplicates": true,
                "onclick": null,
                "showDuration": "300",
                "hideDuration": "1000",
                "timeOut": "5000",
                "extendedTimeOut": "1000",
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
            }
        }
    },
    download: () => {
        const link = document.createElement('a')
        link.href = $('#img-data').attr('src')
        link.download = `ALARMES-LASA-SSR-${ssr.selected.type.toUpperCase()}-${ssr.selected.name}-${ssr.today.toISOString().split('T')[0].replace(/-/g, "")}` // Nome do arquivo ao baixar

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    },
    refresh: {
        areas: () => {
            $.getJSON(`${ssr.workspace}/area/info/${$("#select-categories").val()}`, function (areas) {
                let elem = $('#select-areas').empty()
                console.log(areas)
                for (i in areas)
                    elem.append(`<option value="${areas[i].id}" pa="BR" bi="${areas[i].biome_id}" uf="${areas[i].uf}" >${areas[i].name}</option>`)
                })
        },
        src: () => {
            toastr.info("Atualizando...")
            $("#btn-search").prop('disabled', true).html(`<div class="spinner-border spinner-border-sm mt-1"></div>`)

            ssr.selected.type       = $("#select-type").val()
            ssr.selected.category   = $("#select-categories").val()
            ssr.selected.id         = $("#select-areas").val()
            ssr.selected.acronym    = $("#select-areas option:selected").attr(ssr.selected.category.toLowerCase())
            ssr.selected.name       = $("#select-areas option:selected").text().toUpperCase().replace(/\s+/g, '-')
                
            console.log(ssr.selected)
            $("#img-data").attr("src", `${ssr.workspace}/generated/${ssr.source}/${ssr.selected.type.toUpperCase()}/CEMS_SSR_${ssr.selected.category}_${ssr.selected.id}.png`)
            
            $("#img-data").on("load", function () {
                $("#btn-search").prop('disabled', false).html(`Buscar&nbsp;<i class="fa fa-search"></i>`)
            })
        
        }

    }
}

ssr.init.all()
